// AJAXSettings moved to types/ajaxSettings.ts
// Cookie moved to types/cookie.ts — fnGetCookie, fnSetCookies, fnCopyToClipboard, serialize/deserialize removed (orphaned Orbotnik code, no consumers)
// DisplayOptions moved to types/displayOptions.ts

export function fnIsEmptyObject(obj: any): boolean {
   for (var _ in obj) {
     return false;
   }
   return true;
 }


export function fnFormatBytes(bytes:number, precision:number = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = precision < 0 ? 0 : precision;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return (bytes / Math.pow(k, i)).toFixed(dm) + ' ' + sizes[i];
};

export function fnMillisecondsToStr (piMilliseconds:number,piPrecision:number=0, handleNow:boolean=false) {
    // TIP: to find current time in milliseconds, use:
    // var  current_time_milliseconds = new Date().getTime();
    // console.log(piMilliseconds)
    piPrecision=piPrecision||1
    function numberEnding (number:number) {
        return (number > 1) ? 's' : '';
    }
    function _fnFormatTime(plValue: number): string {
      const lWhole = Math.floor(plValue);
      const dFrac = ((plValue - lWhole) * 60).toFixed(0);
      const formattedDFrac = dFrac.length === 1 ? '0' + dFrac : dFrac;
      return lWhole.toString() + ':' + formattedDFrac;
    }
    var temp = (piMilliseconds / 1000)
    if (+(temp).toFixed(piPrecision)===0) {
      if (handleNow) {
        return "now"
      } else {
        return "0 ms"
      }
    }
    var years = (temp / 31536000)
    if (Math.floor(years)) {
        return years.toFixed(1) + ' year' + numberEnding(years);
    }
    //TODO: Months! Maybe weeks?
    var days = ((temp %= 31536000) / 86400);
    if (Math.floor(days)) {
        return days.toFixed(1) + ' day' + numberEnding(days);
    }
    var hours = ((temp %= 86400) / 3600);
    if (Math.floor(hours)) {
        return _fnFormatTime(hours) + ' hr' + numberEnding(hours);
    }
    var minutes = ((temp %= 3600) / 60);
    if (Math.floor(minutes)) {
        return  _fnFormatTime(minutes) + ' min' + numberEnding(minutes);
    }
    var seconds = temp % 60;
    if (Math.floor(seconds)) {
        return seconds.toFixed(piPrecision) + ' sec' + numberEnding(seconds);
    }
    return (piMilliseconds).toFixed(piPrecision) + ' ms' //+ numberEnding(milliseconds);
}
export type SourceUnits = 'ns' | 'ms'|'s' | 'm' | 'h' | 'h' | 'd' | 'w' | 'f' | 'mo' | 'y'
export const manageTimeSourceUnits = (val: number, sourceUnits?: SourceUnits): number => {
  switch (sourceUnits) {
      case 'ns':
          val = val / 1000;
          break;
      case 's':
          val = val * 1000;
          break;
      case 'm':
          val = val * 1000 * 60;
          break;
      case 'h':
          val = val * 1000 * 60 * 60;
          break;
      case 'd':
          val = val * 1000 * 60 * 60 * 24;
          break;
      case 'w':
        val = val * 1000 * 60 * 60 * 24 * 7;
        break;
      case 'f':
        val = val * 1000 * 60 * 60 * 24*14;
        break;
      case 'mo':
        val = val * 1000 * 60 * 60 * 24 * 365/12;
        break;
      case 'y':
        val = val * 1000 * 60 * 60 * 24 * 365;
        break;
                    
      default:
          // already in ms
          break;
  }

  return val;
}
export function getFormatters(formatterName?:string): Record<string, (input: any, options?: object) => any> {
  const formatters: Record<string, (input: any, options?: object) => any> = {
    'date': function(val: number, options: any = {}) {
      /** 
       * Converts a numeric value to a formatted date string using the locale-specific date representation.
       * @param {number} val - The date value to format. Expected to be a timestamp.
       * @param {object} options - Formatting options.
       * @param {string} [options.dateFormat='en-US'] - The locale string to format the date (e.g., 'en-US', 'fr-FR').
       * @param {string} [options.sourceUnits] - Units of the input timestamp (e.g., 'milliseconds', 'seconds').
       * @returns {string} The formatted date string.
       */
      if (val === null || val === undefined) return val;
      const format = options.dateFormat || 'en-US';
      return new Date(manageTimeSourceUnits(val,options?.sourceUnits)).toLocaleString(format);
    },
    'intldate': function(val: number, options: any = {}) {
    /**
       * Converts a numeric value to a formatted date string using international date formatting.
       * @param {number} val - The date value to format. Expected to be a timestamp or a date-compatible string.
       * @param {object} options - Formatting options.
       * @param {string} [options.dateFormat='en-US'] - The locale string to be used for formatting.
       * @param {object} [options.dateFormatOptions] - 
       *        An object with options to pass to Intl.DateTimeFormat 
       *           {
                      weekday: 'narrow' | 'short' | 'long',
                      era: 'narrow' | 'short' | 'long',
                      year: 'numeric' | '2-digit',
                      month: 'numeric' | '2-digit' | 'narrow' | 'short' | 'long',
                      day: 'numeric' | '2-digit',
                      hour: 'numeric' | '2-digit',
                      minute: 'numeric' | '2-digit',
                      second: 'numeric' | '2-digit',
                      timeZoneName: 'short' | 'long',
                    
                      // Time zone to express it in
                      timeZone: 'Asia/Shanghai',
                      // Force 12-hour or 24-hour
                      hour12: true | false,
                    
                      // Rarely-used options
                      hourCycle: 'h11' | 'h12' | 'h23' | 'h24',
                      formatMatcher: 'basic' | 'best fit'
                    }
       * @param {string} [options.sourceUnits] - Units of the input timestamp (e.g., 'milliseconds', 'seconds').
       * @returns {string} The internationally formatted date string.
       */
      if (val === null || val === undefined) return val;
      if (typeof(val)=='number') {
        val=manageTimeSourceUnits(val,options?.sourceUnits)
      };
      // console.log(fnParseVariableToDate(val),options.dateFormat || 'en-US', options.dateFormatOptions)
      return new Intl.DateTimeFormat(options.dateFormat || 'en-US', options.dateFormatOptions).format(fnParseVariableToDate(val));
      
    },      
    'GB': function(val: number, options: any = {}) {
        return (val / 1e9).toFixed(2) + ' GB';
    },
    'duration': function(val: number, options: any = {}) {
      return fnMillisecondsToStr(manageTimeSourceUnits(val,options?.sourceUnits),options.precision || 1)
    },
    'formatbytes': function(val: number, options: any = {}) {
      return fnFormatBytes(val,options.precision || 1)
    },

    'decimal': function(val: number, options: any = {}) {
      return val.toLocaleString(undefined, {
        maximumFractionDigits: options.precision || 2
      })
    },
    'templatestring': function(val: number, options: any = {}) {
        return `${options.prepend || ''}${val}${options.append || ''}` ;
    },      
    'bool': function(val: any, options: any = {}) {
      const truthyStrings = ["true", "True", "TRUE"];
      const falsyStrings = ["false", "False", "FALSE"];
      let boolValue: boolean;

      if (typeof val === 'number') {
          boolValue = val !== 0;
      } else if (typeof val === 'string') {
          if (truthyStrings.includes(val)) {
              boolValue = true;
          } else if (falsyStrings.includes(val)) {
              boolValue = false;
          } else {
              // Try parsing the string as a number and check if it's non-zero
              const numValue = parseFloat(val);
              boolValue = !isNaN(numValue) && numValue !== 0;
          }
      } else {
          boolValue = !!val; // Convert to boolean using double negation
      }
      // console.log((options.format || 'true_false'),boolValue,typeof(boolValue))
      switch (options.format || 'true_false') {
          case 'yes_no':
              return boolValue ? 'Yes' : 'No';
          case 'bool':
              return boolValue;
          case 'true_false':
          default:
              return boolValue ? 'True' : 'False';
      }
    }
  };
  if (formatterName) {
    const formatter = formatters[formatterName];
    if (!formatter) {
      throw new Error(`Formatter not found: ${formatterName}`);
    }
    return {[formatterName]:formatter};
  }

  // If no specific formatter is requested, return all formatters
  return formatters;
}


export function fnFormatJSON(pSource: string | object, pFormatter: string | object, pGlobalFormatter: string | object ): object {
  // Predefined format functions
  const formatters = getFormatters();
  // console.log(pSource)
  function applyFormatter(ptFormatter: any, key: any, ptSource_key: any): {recurse: boolean, value: any, changed: boolean} {
    // Use destructuring for clarity
    const { formatter, options } = ptFormatter[key] || {};
    // console.log(formatter,ptSource_key, ptFormatter[key])
    if (ptFormatter.hasOwnProperty(key)) {
      if (typeof ptFormatter[key] === 'object') {
        if (formatters[formatter]) {
          return {recurse: false, value: formatters[formatter](ptSource_key, options), changed: true};
        } else if (typeof ptSource_key === 'object') {
          return {recurse: true, value: {}, changed: false};
        }
      } else {
          if (formatters[ptFormatter[key]]) {
            return {recurse: false, value: formatters[ptFormatter[key]](ptSource_key, options), changed: true};
          }
      }     
    }
    // Return a default value if no conditions are met
    return {recurse: false, value: ptSource_key, changed: false};
  }

  function _fnFormatJSON_recurse(ptSource:any, ptFormatter:any, pGlobalFormatter:any): object {
    let newPtSource = {...ptSource}; // Clone the ptSource object

    for (const key in newPtSource) {
      // console.log(newPtSource[key])
        if (newPtSource.hasOwnProperty(key)) {
            // Specific formatter function
            var tOut = applyFormatter(ptFormatter, key ,newPtSource[key])
            if (tOut.recurse) {
                newPtSource[key] = _fnFormatJSON_recurse(newPtSource[key], ptFormatter[key], pGlobalFormatter);
            } else if (tOut.changed) {
                newPtSource[key] = tOut.value;
            }   

            // Wildcard formatter function
            if (!tOut.recurse) {
                tOut = applyFormatter(ptFormatter, "*" ,newPtSource[key])
                if (tOut.recurse) {
                    newPtSource[key] = _fnFormatJSON_recurse(newPtSource[key], ptFormatter['*'], pGlobalFormatter);
                } else if (tOut.changed) {
                    newPtSource[key] = tOut.value;
                }
            }

            // Global formatter function
            tOut = applyFormatter(pGlobalFormatter, key ,newPtSource[key])
            if (tOut.recurse) {
                newPtSource[key] = _fnFormatJSON_recurse(newPtSource[key], ptFormatter[key], pGlobalFormatter);
            } else if (tOut.changed) {
                newPtSource[key] = tOut.value;
            }              

            // Object formatter function
            if (newPtSource[key] !== null && typeof newPtSource[key] === 'object' && !Array.isArray(newPtSource[key])) {
                newPtSource[key] = _fnFormatJSON_recurse(newPtSource[key], ptFormatter['$'] ? ptFormatter['$'] : {}, pGlobalFormatter);
            }
        }
    }
    return newPtSource;
}


  // Try to parse the input, providing meaningful error messages for each possible parse failure.
  try {
    if (typeof pSource === 'string') pSource = JSON.parse(pSource);
  } catch {
    return {error: "Invalid pSource JSON"};
  }

  try {
    if (typeof pFormatter === 'string') pFormatter = JSON.parse(pFormatter);
  } catch {
    return {error: "Invalid pFormatter JSON"};
  }

  try {
    if (typeof pGlobalFormatter === 'string') pGlobalFormatter = JSON.parse(pGlobalFormatter);
  } catch {
    return {error: "Invalid pGlobalFormatter JSON"};
  }  

  return _fnFormatJSON_recurse(pSource as any, pFormatter as any, pGlobalFormatter as any);
};





export function fnIsTrue(poValue:any):boolean {
    var bResponse:boolean=false
    if (typeof(poValue)=='boolean') {
        bResponse = poValue;

    }
    else if (typeof(poValue)=='string') {
        try {
          if (parseInt(poValue)) {
            bResponse=true
          } else {
            bResponse = JSON.parse(poValue)
          }
        }
        catch (oError) {
          bResponse = JSON.parse(poValue);
      };
    }
    else if (typeof(poValue)=='number') {
        if (poValue==0) {
            bResponse=false
        } else {
            bResponse=true
        }
    }
    else {
      bResponse=typeof(poValue)===undefined
    };
   return bResponse
}

export function fnTimestamp(str: string | number | Date): number {
    return new Date(str).getTime();
};

export function fnTimeStringToDate(psTimeString:string){// time(HH:MM:SS.mss) // optimized
  var tTime=psTimeString.split(':')
  var lH = 0
  var lM = 0
  var lS = 0

  if (tTime[2]) {
    lH = parseInt(tTime[0])
    lM = parseInt(tTime[1])
    lS = parseInt(tTime[2])
  } else if (tTime[1]) {
    lM = parseInt(tTime[0])
    lS = parseInt(tTime[1])
  } else {
    lS = parseInt(tTime[0])
  }

  return new Date(1970,0,1,lH,lM,lS)
}

export function fnParseVariableToDate(input: Date | string | number): Date {
  if (input instanceof Date) {
    return input;
  } else if (typeof input === 'string') {
    return new Date(input);
  } else {
    return new Date(input);
  }

}


/**
 * Function that parses a JSON string into an object.
 * @param {string|null} psSource - The JSON string to be parsed.
 * @param {boolean} pbRaiseError - Optional parameter indicating whether an error should be raised when the JSON string is invalid. Defaults to true.
 * @returns {any} - Returns the parsed object, or undefined if an error occurs and pbRaiseError is false.
 */
export function fnJSONParse(psSource?:string|null,pbRaiseError:boolean=true): any {
  try {
    return JSON.parse(psSource!)
  }
  catch (eError) {
    if (pbRaiseError) {
      throw eError
    } else {
      return {}
    }
  }
};
type JsonObject = { [key: string]: any };

export const extractMatchingTrends = (data: JsonObject, patterns: string[]): JsonObject => {
    const result: JsonObject = {};

    // Convert patterns to regex objects
    const regexes = patterns.map(pattern => new RegExp(pattern));

    const checkKey = (key: string) => {
        for (const regex of regexes) {
            if (regex.test(key)) {
                return true;
            }
        }
        return false;
    };
    if (data) {
    for (const [key, value] of Object.entries(data)) {
      if (checkKey(key)) {
          result[key] = value;
      }
    }}

    return result;
};

type Source = { [key: string]: any };

export const extractValues = (source: Source, paths: string[]): [string, any][] => {
    const readKeys = (source: Source | any[], path: string, currentKeyAddress: string = ""): [string, any][] => {
        let extracted: [string, any][] = [];

        const rPattern = /(^|.+?\.)((r".+?"))(.*)/;
        const match = path.match(rPattern);

        if (match) {
            const precedingString = match[1].endsWith('.') ? match[1].slice(0, -1) : match[1];
            const rSequenceString = match[2].slice(2, -1);
            const subsequentString = match[4];

            let tMatched: any;
            if (!precedingString) {
                tMatched = source;
            } else {
                tMatched = fnDictGetIndex(source, precedingString);
            }

            if (typeof tMatched !== "object") {
                const regex = new RegExp(rSequenceString);
                if (regex.test(String(tMatched))) {
                    extracted.push([currentKeyAddress + precedingString, tMatched]);
                }
            } else if (tMatched instanceof Array) {
                tMatched.forEach((item, idx) => {
                    extracted.push(...readKeys(item, subsequentString, `${currentKeyAddress}${precedingString}[${idx}].`));
                });
            } else {
                Object.entries(tMatched).forEach(([key, newSource]) => {
                    const regex = new RegExp(rSequenceString);
                    if (regex.test(key)) {
                        currentKeyAddress = currentKeyAddress.endsWith('.') ? currentKeyAddress.slice(0, -1) : currentKeyAddress;
                        extracted.push(...readKeys(newSource as any[] | Source, subsequentString, `${currentKeyAddress}${precedingString}.${key}.`));
                    }
                });
            }
        } else {
            let result: any;
            if (!path) {
                result = source;
            } else {
                result = fnDictGetIndex(source, path);
            }
            if (result !== undefined) {
                currentKeyAddress = currentKeyAddress.startsWith('.') ? currentKeyAddress.slice(1) : currentKeyAddress;
                extracted.push([currentKeyAddress + path, result]);
            }
        }

        return extracted;
    };

    let results: [string, any][] = [];
    paths.forEach(path => {
        results.push(...readKeys(source, path));
    });

    return results;
}

export const fnDictGetIndex = (ptDict:any, psIndex:string, pNoneEquivalent:any=undefined, poValueIfNone:any=undefined,psLodashIndexesSplit:string='.') => {
  const sReturn = String(psIndex).split(psLodashIndexesSplit).reduce((acc:any, v:any) => {
    try {
      // if (v.startsWith('[') && v.endsWith(']')&& !isNaN(Number(v[1:-1]))) {
      //   console.log('ya')
      // }
      acc = acc[v]
    } catch (e) {
      return poValueIfNone
    }
    return acc
  }, ptDict)
  return sReturn === undefined ? poValueIfNone 
    : sReturn === pNoneEquivalent ? poValueIfNone 
    : sReturn
}
// export const fnDictGetIndex = (ptDict:any, psIndex:string, pNoneEquivalent:any=undefined, poValueIfNone:any=undefined,psLodashIndexesSplit:string='.') => {
export const fnDictHasIndex = (
    ptDict: any,
    psIndex: string,
    pNoneEquivalent: any = undefined,
    psLodashIndexesSplit: string = '.'
  ): boolean => {
    const foundValue = String(psIndex).split(psLodashIndexesSplit).reduce((acc: any, key: string) => {
      if (acc === undefined || acc === null || !(key in acc)) {
        return undefined;
      }
      return acc[key];
    }, ptDict);
    // console.log(foundValue,pNoneEquivalent)
    if (foundValue === undefined || foundValue === pNoneEquivalent) {
      return false;
    }
    
    return true;
  };
export const fnDictSetIndex = (ptDict:object, psIndex:string, poNewValue:any,psLodashIndexesSplit:string='.') => {
  if (Object(ptDict) !== ptDict) return ptDict; // When obj is not an object
  // If not yet an array, get the keys from the string-path
  var tIndex:string[] = psIndex.split(psLodashIndexesSplit)
  //@ts-ignore
  tIndex.slice(0,-1).reduce(
    (a, c, i): any => // Iterate all of them except the last one
        {
        //@ts-ignore
        return Object(a[c as keyof typeof a]) === a[c as keyof typeof a] // Does the key exist and is its value an object?

          // Yes: then follow that path
          ? a[c as keyof typeof a]
          // No: create the key. Is the next key a potential array-index?
          //@ts-ignore
          : a[c as keyof typeof a] = Math.abs(parseInt(tIndex[i + 1])) >> 0 === +tIndex[i + 1]
            ? [] // Yes: assign a new array object
            : {} // No: assign a new plain object
          ;
      } // No: assign a new plain object
        , ptDict
      )[tIndex[tIndex.length-1]] = poNewValue; // Finally assign the value to the last key
  return ptDict; // Return the top-level object to allow chaining
};

// Warn if overriding existing method
// if(Array.prototype.equals)
//     console.warn(`Overriding existing Array.prototype.equals. Possible causes: New API defines the method, 
//     there's a framework conflict or you've got double inclusions in your code.`);
// attach the .equals method to Array's prototype to call it on any array
//@ts-ignore
Array.prototype.equals = function (array: string | any[],exactorder: any) {
    // if the other array is a falsy value, return
    if (!array) {
      // console.log('not array')
        return false;
      }
    // if the argument is the same array, we can be sure the contents are same as well
    if(array === this) {
      // console.log('abs eq')
        return true;
      };
    // compare lengths - can save a lot of time
    if (this.length != array.length) {
      // console.log('dif length')
        return false;
      }
    for (var i = 0, l=this.length; i < l; i++) {
        // Check if we have nested arrays
        if (this[i] instanceof Array && array[i] instanceof Array) {
            // recurse into the nested arrays
            if (!this[i].equals(array[i],exactorder)) {
                return false;
              }
        } else {
            if (exactorder) {
                if (this[i] != array[i]) {
                    // Warning - two different object instances will never be equal: {x:20} != {x:20}
                    // console.log('f')
                    // console.log(this[i] + ' != ' + array[i])
                    return false;
                  }
            }  else {
                if (!array.includes(this[i])) {
                    // console.log('array not includes ' + this[i])
                    return false;
                };
            };
        }
    };

    return true;
}

/**
 * Compares two objects recursively and returns true if they are equal.
 * If the objects have different constructors, they're not equal.
 * If the objects are dates, compares them by value.
 * If the objects are functions, compares their toString() values.
 * If the objects are arrays, compares them element-by-element.
 * If the objects are objects, compares their properties recursively.
 * @param {any} obj1 - The first object to compare.
 * @param {any} obj2 - The second object to compare.
 * @returns {boolean} - True if the objects are equal, false otherwise.
 */
export function fnCompareArrayElements(obj1: any, obj2: any): boolean {
  // If the objects are identical, return true
  if (obj1 === obj2) {
    return true;
  }

  // If either object is null or undefined, they're not equal
  if (!obj1 || !obj2) {
    return false;
  }

  // If the objects have different constructors, they're not equal
  if (obj1.constructor !== obj2.constructor) {
    return false;
  }

  // If the objects are dates, compare them by value
  if (obj1 instanceof Date && obj2 instanceof Date) {
    return obj1.getTime() === obj2.getTime();
  }

  // If the objects are functions, they're equal if their toString() matches
  if (typeof obj1 === 'function' && typeof obj2 === 'function') {
    return obj1.toString() === obj2.toString();
  }

  // If the objects are arrays, compare them element-by-element
  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    if (obj1.length !== obj2.length) {
      return false;
    }
    for (let i = 0; i < obj1.length; i++) {
      if (!fnCompareArrayElements(obj1[i], obj2[i])) {
        return false;
      }
    }
    return true;
  }

  // If the objects are objects, compare their properties recursively
  if (typeof obj1 === 'object' && typeof obj2 === 'object') {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (const key of keys1) {
      if (!obj2.hasOwnProperty(key)) {
        return false;
      }
      if (!fnCompareArrayElements(obj1[key], obj2[key])) {
        return false;
      }
    }
    return true;
  }

  // If none of the above conditions are true, the objects aren't equal
  return false;
}

/**
 * Creates a throttled function that limits the execution of the provided function
 * to once every `delay` milliseconds.
 *
 * @param func - The function to throttle.
 * @param interval - The delay in milliseconds.
 * @returns A throttled function.
 */
export function fnFuncThrottle(func: (...args: any[]) => void, interval: number, accumulator: 'last' | 'sum' | 'max' | 'min' | 'avg' | 'first' ='last', runFirstTime:boolean=true): (...args: any[]) => void {
  let timeoutId: number | null = null;
  let lastExecTime = 0;
  let storedArgs: any[] = [];

  const executeWithAccumulator = (args: any[]) => {
    let argToUse;
    switch (accumulator) {
      case 'sum':
        argToUse = args.reduce((acc, val) => acc + val, 0);
        break;
      case 'max':
        argToUse = Math.max(...args);
        break;
      case 'min':
        argToUse = Math.min(...args);
        break;
      case 'avg':
        argToUse = args.reduce((acc, val) => acc + val, 0) / args.length;
        break;
      case 'first':
        argToUse = args[0];
        break;
      case 'last':
      default:
        argToUse = args[args.length - 1];
        break;
    }
    func(argToUse);
  };

  return (...args: any[]) => {
    const currentTime = new Date().getTime();
    if (currentTime - lastExecTime < interval) {
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
      }
      storedArgs = storedArgs.concat(args);
      timeoutId = setTimeout(() => {
        lastExecTime = new Date().getTime();
        executeWithAccumulator(storedArgs);
        storedArgs = []; // Reset stored arguments after execution
      }, interval);
    } else {
      lastExecTime = currentTime;
      if (runFirstTime) executeWithAccumulator(args);
      storedArgs = []; // Reset stored arguments after execution
    }
  };
}

/**
 * Creates a throttled function that:
 * - Waits for `delay` ms before the first execution.
 * - Ensures subsequent calls are not executed more frequently than once every `delay` ms.
 *
 * @param func - The function to throttle.
 * @param delay - The delay in milliseconds.
 * @returns A throttled function.
 */
export function fnDelayedThrottle(func: (...args: any[]) => void, delay: number): (...args: any[]) => void {
  let timeoutId: number | null = null;
  let lastExecTime = 0;
  // console.log('delayed')
  return (...args: any[]) => {
      const currentTime = new Date().getTime();
      const elapsed = currentTime - lastExecTime;

      const execute = () => {
          lastExecTime = new Date().getTime();
          func(...args);
      };

      if (elapsed < delay) {
          if (timeoutId !== null) {
              clearTimeout(timeoutId);
          }
          timeoutId = setTimeout(execute, delay - elapsed);
      } else {
          execute();
      }
  };
}

/**
 * Creates a function that ensures the provided function is only executed once.
 * Subsequent calls to the created function within a short time period will be ignored.
 *
 * @param func - The function to be executed once.
 * @returns A function that wraps the provided function and enforces execution only once.
 */
export function fnFuncOnlyRunOnce(func: (...args: any[]) => void): (...args: any[]) => void {
  return fnFuncThrottle(func, 10000000000);
};

/**
 * Creates a debounced function that delays the execution of the provided function
 * until `delay` milliseconds have passed since the last invocation.
 *
 * @param func - The function to debounce.
 * @param delay - The delay in milliseconds.
 * @returns A debounced function.
 */
export function fnDebounceFunc(func: (...args: any[]) => void, delay: number): (...args: any[]) => void {
  return (function() {
  let timeoutId: number | null = null;

  return (...args: any[]) => {
    if (timeoutId !== null) {
      // console.log('clearing it',timeoutId)
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      // console.log('executing it',timeoutId)
      func(...args);
        // func.apply(this, args);
    }, delay);
    // console.log('create timeout',timeoutId)
  };
  })();
}


export function fnHandleElementVisibility(poElement: Element, pfnCallback: (arg0: any) => void) {
  if (pfnCallback && typeof pfnCallback === "function") {
    pfnCallback(poElement);
  }
}

// fnObserveElement moved to services/observers.ts (cleaned up, no React hook dependencies)

export function fnReload(): void {
  setTimeout(function fn() {location.reload();},1000)
}


export function getJwtToken(): string {
    const sToken = sessionStorage.getItem("jwt") || localStorage.getItem("jwt")
    return sToken||''
};

export function setJwtToken(token:string): void {
    sessionStorage.setItem("jwt", token)
    localStorage.setItem("jwt", token)
}
export function getRefreshToken(): string {
    return sessionStorage.getItem("refresh_token") || ''
}
export function setRefreshToken(token: string): void {
    sessionStorage.setItem("refresh_token", token)
}
export function clearRefreshToken(): void {
    sessionStorage.removeItem("refresh_token")
}
export function getTokenExpiresAt(): number {
    const raw = sessionStorage.getItem("jwt_expires_at") || localStorage.getItem("jwt_expires_at")
    const n = raw ? parseInt(raw, 10) : 0
    return Number.isFinite(n) ? n : 0
}
export function setTokenExpiresAt(epochMs: number): void {
    const s = String(epochMs)
    sessionStorage.setItem("jwt_expires_at", s)
    localStorage.setItem("jwt_expires_at", s)
}
export function clearTokenExpiresAt(): void {
    sessionStorage.removeItem("jwt_expires_at")
    localStorage.removeItem("jwt_expires_at")
}
export function createDropdownOptions(enumOrSet: any): { value: string; label: string }[] {
  // Check if the provided value is a Set
  if (enumOrSet instanceof Set) {
    return Array.from(enumOrSet).map(value => ({
      value: value,
      label: value.charAt(0).toUpperCase() + value.slice(1) // Capitalize first letter for the label
    }));
  }
  // Otherwise, assume it's an object (like an enum)
  else {
    return Object.keys(enumOrSet).map(key => ({
      value: enumOrSet[key],
      label: enumOrSet[key].charAt(0).toUpperCase() + enumOrSet[key].slice(1) // Capitalize first letter for the label
    }));
  }
}


export function flattenObject(obj: any, parentKey: string = '', result: { [key: string]: any } = {}): { [key: string]: any } {
  if (!obj) {return obj}
  for (const [key, value] of Object.entries(obj)) {
      const fullKey = parentKey ? `${parentKey}.${key}` : key;

      if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
          flattenObject(value, fullKey, result);
      } else {
          result[fullKey] = value;
      }
  }
  return result;
}


function hsvToRgb(h:number, s:number, v:number) {
  let r, g, b, i, f, p, q, t;
  if (s === 0) {
      r = g = b = v; // achromatic
  } else {
      h /= 60;
      i = Math.floor(h);
      f = h - i;
      p = v * (1 - s);
      q = v * (1 - s * f);
      t = v * (1 - s * (1 - f));
      switch (i % 6) {
          case 0: r = v; g = t; b = p; break;
          case 1: r = q; g = v; b = p; break;
          case 2: r = p; g = v; b = t; break;
          case 3: r = p; g = q; b = v; break;
          case 4: r = t; g = p; b = v; break;
          case 5: r = v; g = p; b = q; break;
      }
  }
  return '' 
  // `rgb(${Math.round(r * 255)}, ${Math.round(g * 255)}, ${Math.round(b * 255)})`;
}
export function hsvToHsl(H: number, S: number, V: number): [number,number,number] {
  // console.log(`input H: ${H}, S: ${S}, V: ${V}`)
  S /= 100;
  V /= 100;
  let L = (2 - S) * V / 2;

  if (L != 0) {
    if (L == 1) {
      S = 0
    } else if (L < 0.5) {
      S = S * V / (L * 2)
    } else {
      S = S * V / (2 - L * 2)
    }
  }

  L *= 100;
  S *= 100;
  // console.log(`output H: ${H}, S: ${S}, V: ${L}`)
  return [H,S,L]
}

export function hslToHsv(H: number, S: number, L: number): [number, number, number] {
  // Convert S and L from percentages to fractions
  S /= 100;
  L /= 100;

  let V: number;
  let newS: number;

  if (L === 0) {
    // If lightness is 0, then hue and saturation don't matter.
    return [H, 0, 0];
  }

  if (S === 0) {
    // If saturation is 0, the color is a shade of grey.
    V = L; // Value equals lightness in this case
    newS = 0; // Saturation in HSV remains 0
  } else {
    // Otherwise, calculate V and newS
    V = L + S * Math.min(L, 1 - L);
    newS = (2 * (1 - L / V)) * 100;
  }

  V *= 100; // Convert back to percentage
  H = Math.round(H); // Round hue to the nearest integer

  return [H, newS, V];
}


// paintColorWheelToCanvas.ts

/**
 * Paints a color wheel to a canvas element.
 *
 * @param canvas - The canvas element to paint the color wheel on.
 * @param size - The diameter of the color wheel in pixels.
 * @returns The canvas element for chaining.
 */
export default function paintColorWheelToCanvas(canvas: HTMLCanvasElement, size: number): HTMLCanvasElement {
  const half: number = size / 2;
  const radius: number = Math.sqrt(2) * half;
  const deg: number = Math.PI / 180;
  const pi2: number = Math.PI * 2;

  canvas.width = canvas.height = size;
  const ctx: CanvasRenderingContext2D | null = canvas.getContext('2d');

  if (!ctx) {
      throw new Error('Could not get canvas context');
  }

  // .02: To prevent empty blank line and corresponding moire
  // only non-alpha colors are cared now
  const thetaOffset: number = 0.5 * deg + 0.02;

  // Transform coordinate system so that angles start from the top left, like in CSS
  ctx.translate(half, half);
  ctx.rotate(-Math.PI / 2);
  ctx.translate(-half, -half);

  for (let i: number = 0; i < 360; i += 0.5) {
      ctx.fillStyle = `hsl(${i}, 100%, 50%)`;
      ctx.beginPath();
      ctx.moveTo(half, half);

      const beginArg: number = i * deg;
      const endArg: number = Math.min(pi2, beginArg + thetaOffset);

      ctx.arc(half, half, radius, beginArg, endArg);

      ctx.closePath();
      ctx.fill();
  }

  return canvas;
}


export function timestampWithMilliseconds(): number {
  const now = new Date(); // Get the current date and time
  const timestamp = now.getTime(); // This gives you the Unix timestamp in milliseconds
  return timestamp;
}

export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}

type GenericObject = { [key: string]: any };

export function isObject(item: any): item is GenericObject {
    return (item && typeof item === 'object' && !Array.isArray(item));
}

function isArray(item: any): item is any[] {
    return Array.isArray(item);
}

export function findCommonPropertiesWithDifferences(obj1: GenericObject, obj2: GenericObject): [GenericObject, GenericObject] {
    let common: GenericObject = {};
    let differences: GenericObject = {};

    const allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

    allKeys.forEach(key => {
        const val1 = obj1[key];
        const val2 = obj2[key];

        if (key in obj1 && key in obj2) {
            if (isObject(val1) && isObject(val2)) {
                const [nestedCommon, nestedDifferences] = findCommonPropertiesWithDifferences(val1, val2);
                common[key] = nestedCommon;
                differences[key] = nestedDifferences;
            } else if (isArray(val1) && isArray(val2)) {
                common[key] = val1.filter(value => val2.includes(value));
                differences[key] = val1.length !== common[key].length || val2.length !== common[key].length ? '*' : undefined;
            } else {
                common[key] = val1;
                differences[key] = val1 !== val2 ? '*' : undefined;
            }
        } else {
            common[key] = val1 !== undefined ? val1 : val2;
            differences[key] = '*';
        }
    });

    return [common, differences];
}


// --- Moved from helpers.tsx ---

export function deepMerge(original: any, update: any): any {
  let output = Object.assign({}, original);
  if (isObject(original) && isObject(update)) {
      Object.keys(update).forEach(key => {
          if (isObject(update[key])) {
              if (!(key in original))
                  Object.assign(output, { [key]: update[key] });
              else
                  output[key] = deepMerge(original[key], update[key]);
          } else {
              Object.assign(output, { [key]: update[key] });
          }
      });
  }
  return output;
}

// isObject already exists above (line 1127) — now exported

export function generateUUID(): string {
  var d = new Date().getTime();
  var d2 = (performance && performance.now && (performance.now()*1000)) || 0;
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16;
      if(d > 0){
          r = (d + r)%16 | 0;
          d = Math.floor(d/16);
      } else {
          r = (d2 + r)%16 | 0;
          d2 = Math.floor(d2/16);
      }
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}